import React from 'react';
import PropTypes from 'prop-types';
import WorkspaceService from 'services/WorkspaceService';
import CompetencyGrid from '../CompetencyGrid';
import useDocumentItem from './useDocumentItem';
import useEnrollmentsAndLinkedItems from './useEnrollmentsAndLinkedItems';
import useDocumentItemsPerformance from './useDocumentItemsPerformance';

function CompetencyReportContainer({ cohortId, deployment, documentId, documentItemId, ...props }) {
  const { deploymentId } = deployment;
  const workspaceId = WorkspaceService.getSelectedWorkspaceId();

  const {
    loading: loadingEnrollments,
    error: errorLoadingEnrollments,
    data: {
      enrollments,
      linkedDocumentItems,
    },
  } = useEnrollmentsAndLinkedItems(cohortId, deploymentId);

  const {
    loading: loadingDocument,
    error: errorLoadingDocumentItems,
    data: {
      parentDocumentItem,
      childDocumentItems,
      documentItems,
    },
  } = useDocumentItem(workspaceId, documentId, documentItemId);

  const {
    errors: errorsLoadingPerformance,
    data: performanceByDocumentItem,
  } = useDocumentItemsPerformance(cohortId, deployment, linkedDocumentItems || documentItems);

  const error = errorLoadingEnrollments || errorLoadingDocumentItems || errorsLoadingPerformance;
  if (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return null;
  }

  if (documentId && documentItemId) {
    return (
      <CompetencyGrid
        isLoading={loadingEnrollments || loadingDocument}
        cohortId={cohortId}
        enrollments={enrollments}
        deploymentId={deploymentId}
        parentDocumentItem={parentDocumentItem}
        childDocumentItems={childDocumentItems}
        performanceByDocumentItem={performanceByDocumentItem}
        {...props}
      />
    );
  }

  return (
    <CompetencyGrid
      isLoading={loadingEnrollments}
      cohortId={cohortId}
      enrollments={enrollments}
      deploymentId={deploymentId}
      childDocumentItems={linkedDocumentItems}
      performanceByDocumentItem={performanceByDocumentItem}
      {...props}
    />
  );
}

CompetencyReportContainer.propTypes = {
  cohortId: PropTypes.string.isRequired,
  deployment: PropTypes.object.isRequired,
  documentId: PropTypes.string,
  documentItemId: PropTypes.string,
};

export default CompetencyReportContainer;
